import { render } from "./Solleciti.vue?vue&type=template&id=617a73fd&scoped=true"
import script from "./Solleciti.vue?vue&type=script&lang=js"
export * from "./Solleciti.vue?vue&type=script&lang=js"

import "./Solleciti.vue?vue&type=style&index=0&id=617a73fd&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617a73fd"]])

export default __exports__